import {
  PlansCountByZipQuery,
  PlansCountByZipQueryVariables,
  usePlansCountByZipQuery
} from '../documents';
import * as Apollo from '@apollo/client';

export function useMaPlansCount(
  zip?: string | null,
  options: Apollo.QueryHookOptions<PlansCountByZipQuery, PlansCountByZipQueryVariables> = {}
) {
  const { data, loading, called } = usePlansCountByZipQuery({
    variables: { zip: zip! },
    skip: !zip,
    ...options
  });

  const maPlansPercent = data ? Math.floor(data.plansCountByZip.maPlansCount * 100 / data.plansCountByZip.maPlansTotalCount) : null;

  const maPlansCount = data ? data!.plansCountByZip.maPlansCount : null;

  const maOrgCount = data ? data!.plansCountByZip.maPlansParentOrgCount : null;

  const pdpPlansCount = data ? data!.plansCountByZip.pdpPlansCount : null;

  const pdpOrgCount = data ? data!.plansCountByZip.pdpPlansParentOrgCount : null;

  const totalOrgCount = data ? data!.plansCountByZip.maAndPdpPlansParentOrgCount : null;

  const totalPlansCount = (parseFloat(maPlansCount) || 0) + (parseFloat(pdpPlansCount) || 0);

  return {
    totalPlansCount,
    totalOrgCount,
    maPlansPercent,
    maPlansCount,
    maOrgCount,
    pdpPlansCount,
    pdpOrgCount,
    loading: loading || !called,
  };
}
